import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import * as types from '../../../constants/actionTypes';
import PropTypes from 'prop-types'
import Drawer from '../../Common/Drawer/Drawer';
import LoadingIndicator from '../../Common/LoadingIndicator/LoadingIndicator';
import Notification from '../../Common/Notification';
import { NavigateToRouteWithDashboardParams } from '../../../helpers/routing';
import { Routes } from '../../../constants/routes';
import Button from '../../Common/Button';

export class ReassignTasksDrawer extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            users: [],          // { id, name } 
            isLoading: false
        };
    }

    componentDidMount = async () => {
        await this.loadFilters();
    }

    loadFilters = async () => {

        this.setState({ isLoading: true });
        try {
            const response = await this.props.locationDashboardActions.getTaskReassignments(this.props.locationKey);
            if (response.type === types.LOAD_TASK_REASSIGNMENTS_SUCCESS) {
                this.setState({
                    users: response.payload.users
                });
            } else if (response.type === types.LOAD_TASK_REASSIGNMENTS_FAILURE) {
                Notification("error", "Error", response.payload.message);
            }
        } catch (error) {
            Notification("error", "Error", error);
        } finally {
            this.setState({ isLoading: false });
        }            

    }

    viewAssignments = (user) => {
        const urlParams = {
            locationKeys: [this.props.locationKey],
            responsibleUserName: [user.name]
        };
        NavigateToRouteWithDashboardParams(Routes.Tasks, urlParams, false);
    }

    render() {

        return (
            <Drawer isWide={false} title='Reassign Tasks' onSaveClick={this.onSaveClick} saveText='Save' onCancelClick={this.props.onCancel}>
                <LoadingIndicator isLoading={this.state.isLoading}>
                    <div className="bulk-reassign-task-drawer">
                        <div className="mb-4">The following tasks are assigned to an individual that is no longer active in this subscription.</div>
                        {this.state.users && this.state.users.length > 0 &&
                            <Fragment>
                                {this.state.users.map(user => {
                                    return (
                                        <div key={user.name} className="row">
                                            <div className="col-12">
                                                <Button type="button" bootstrapClass="btn btn-link" onClick={() => this.viewAssignments(user)} text={user.name} />
                                            </div>
                                        </div>
                                    );
                                })}                                
                            </Fragment>
                        }
                    </div>
                </LoadingIndicator>
            </Drawer>            
        )
    }
}

ReassignTasksDrawer.propTypes = {
    locationDashboardActions: PropTypes.object.isRequired,
    onComplete: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    locationKey: PropTypes.string.isRequired
};


export default connect(null, null)(ReassignTasksDrawer);